
import * as Moment from 'moment';
import { IDs } from '../../helpers/IDs';
import { StructureService } from '../../services/structure_service';
import { getEmissionsFaktor } from './getEmmissionsFaktor';
import { getCO2MehrkostenBase } from './getCO2MehrkostenBase';

export function getCO2Preise() {
    return { 2021: 25, 2022: 30, 2023: 30, 2024: 45, 2025: 55, 2026: 55 };
}

export function processCO2Mehrkosten(data: any, structureService: StructureService) {
    const maxJahr = Moment().year();
    const fromJahr = 2021;

    const co2_preise: any = getCO2Preise();
    data[IDs.CO2_MEHRKOSTEN] = {};

        let co2_diesel_last = 0;
        let co2_benzin_last = 0;
        let co2_heizoel_last = 0;
        let co2_erdgas_last = 0;
        let co2_fluessiggas_last = 0;

    for (let jahr = fromJahr; jahr <= maxJahr; jahr++) {
        const baseJahr = jahr;
        const co2_preis: number = co2_preise[jahr];
        const heizwerte = data[IDs.ENT_PARAMETER_HEIZWERTE];
        const heizwertRow: any = findRow(heizwerte, jahr);
        const kennzahlen = data[IDs.KENNZIFFERN_BERECHNET][baseJahr];
        const base = getCO2MehrkostenBase();
        const energietraeger = base.map((item: any) => {
            return {
                key: item.key,
                name: item.name,
                faktor: getEmissionsFaktor(data, null, jahr, item.key),
                heizwert: heizwertRow && heizwertRow[translateKeyForHeizwert(item.key)]
                    ? heizwertRow[translateKeyForHeizwert(item.key)]
                    : 1
            };
        });
        // console.log('processCO2Mehrkosten: ', energietraeger);

        const et_diesel = energietraeger.find((et: any) => et.key === 'diesel');
        const et_benzin = energietraeger.find((et: any) => et.key === 'ottokraftstoff');
        const et_heizoel = energietraeger.find((et: any) => et.key === 'heizoel_leicht');
        const et_fluessiggas = energietraeger.find((et: any) => et.key === 'fluessiggas');
        const et_erdgas = energietraeger.find((et: any) => et.key === 'erdgas');
        // durch 1 Mio. Teilen, weil wir einmal von Gramm auf Tonnen umrechnen
        const co2_diesel = ((kennzahlen['diesel_verbrauch'] || 0) * et_diesel.heizwert * et_diesel.faktor) || co2_diesel_last;
        const co2_benzin = ((kennzahlen['benzin_verbrauch'] || 0) * et_benzin.heizwert * et_benzin.faktor) || co2_benzin_last;
        const co2_heizoel = ((kennzahlen['co2_fussabdruck_hel_liter_menge'] || 0) * et_heizoel.heizwert * et_heizoel.faktor) || co2_heizoel_last;
        const co2_erdgas = ((kennzahlen['verbrauch_waerme_erdgas_kwh'] || 0) * et_erdgas.faktor) || co2_erdgas_last;
        const co2_fluessiggas = ((kennzahlen['verbrauch_waerme_fluessiggas_kwh'] || 0) * et_fluessiggas.faktor) || co2_fluessiggas_last;

        if (co2_diesel > 0) { co2_diesel_last = co2_diesel; }
        if (co2_benzin > 0) { co2_benzin_last = co2_benzin; }
        if (co2_heizoel > 0) { co2_heizoel_last = co2_heizoel; }
        if (co2_erdgas > 0) { co2_erdgas_last = co2_erdgas; }
        if (co2_fluessiggas > 0) { co2_fluessiggas_last = co2_fluessiggas; }

        // console.log('OEL', kennzahlen['oel_verbrauch_l'], et_heizoel, kennzahlen);

        const co2_total = co2_diesel + co2_benzin + co2_heizoel + co2_erdgas + co2_fluessiggas;
        const mehr_kosten = co2_total * co2_preis;
        // console.log('CO2: Total: ', jahr, co2_total, mehr_kosten);
        data[IDs.CO2_MEHRKOSTEN][jahr] = mehr_kosten;
    }
    function findRow(rows: Array<any>, jahr: number) {
        let rowFound: any = undefined;
        (rows || []).forEach((row: any) => {
            // Wenn wir noch keine Row gefunden haben, nehmen wir die
            if (!rowFound) {
                rowFound = row;
                return;
            }
            // Wir hatten schonmal eine row gefunden
            if (rowFound.jahr > jahr && row.jahr <= jahr) {
                // Diese war größer als das Jahr, wir suchen aber eigentlich das Jahr, das gleich oder kleiner ist
                rowFound = row;
                return;
            }
            // Wir hatten schonmal eine Row, die gleich oder kleiner War
            if (rowFound.jahr < jahr && row.jahr <= jahr && row.jahr > rowFound.jahr) {
                rowFound = row; // Dieses Jahr ist besser
                return;
            }
        });
        return rowFound;
    }
    function translateKeyForHeizwert(key: string) {
        if (key === 'fluessiggas') { return 'fluessiggas_l'; }
        if (key === 'diesel') { return 'dieselkraftstoffe'; }
        if (key === 'ottokraftstoff') { return 'ottokraftstoffe'; }
        if (key === 'biomasse_holz') { return 'brennholz_hart'; }

        return key;
    }
}
